// extracted by mini-css-extract-plugin
module.exports = {"row":"errorPage_row__2MIC0","error-pagecont":"errorPage_error-pagecont__2JgCG","img-error":"errorPage_img-error__3qisq","content-error":"errorPage_content-error__36GYJ"};